import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { getApi } from "../../api/endpoints";
import ListingPageComponent from '../../components/ListingPageComponent';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import UI_ACTIONS from '../../data/UiActionConstants';
import UiAction from '../../components/UiAction';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import FiltersPartial from "./FiltersPartial.js";


const Index = () => {
  const [filtersModel, setFiltersModel] = useState({})
  const navigate = useNavigate();
  const defaultHeaderConfig = { disableSort: true };
  const headers = [
    {
      ...defaultHeaderConfig,
      label: "ID",
      attr: "id",
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: "Name",
      attr: "name",
    },
    {
      ...defaultHeaderConfig,
      label: "Vehicle Type",
      attr: "vehicle_type_type",
    },
    {
      ...defaultHeaderConfig,
      label: "Offer Type",
      attr: "offer_type_name",
    },
    {
      ...defaultHeaderConfig,
      label: "Last Activation Date",
      attr: "last_activation_date",
      disableSort: false
    },
    {
      disableSort: true,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.update_offer.name)}>
            <div style={{ cursor: 'pointer' }} onClick={(e) => onEditClick(row.id)}>
              <FontAwesomeIcon icon={faEdit} />
            </div>
          </UiAction>
        </div>
      }
    }
  ];

  const tableHeaderActionsComponent = () => {
    return <React.Fragment>
      <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.create_offer.name)}>
        <button className="s-btn me-2" style={{ width: "150px" }} onClick={onNewClick}>
          <span>Add New Offer</span>
        </button>
      </UiAction>
    </React.Fragment>
  }

  const onNewClick = () => {
    navigate('/offers/new');
  }

  const onEditClick = (id) => {
    navigate(`/offers/${id}/edit`)
  }

  return <ListingPageComponent
    key={PAGES.OffersListingPage.name}
    uiPage={uiManager.getUiPage(PAGES.OffersListingPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard'}, { label: "Offers" }]}
    listingMutation={getApi('offers')}
    className="cp-listing-page"
    contentHeading="Offer List - Results"
    headers={headers}
    recordsKey="offers"
    tableHeaderActionsComponent={tableHeaderActionsComponent()}
    filtersModel={filtersModel}
    filters={
      <FiltersPartial
        filtersModel={filtersModel}
        setFiltersModel={setFiltersModel}
      />
    }
    searchBy={['ID', 'Name']}
  />
};

export default Index;
